<template>
    <div class="gift-confirmation-content">
        <p v-if="error" class="error-msg">{{ error }}</p>

        <h1>{{ formatPrice(totalAmount, true) }}</h1>
        <p class="gift-confirmation-subheading">
            <span v-if="numRecipients > 1">{{ formatPrice(giftData.amountEach, true) }} Each Going to:</span>
            <span v-else>To:</span>
        </p>
        <p v-for="recipient in giftData.recipients">{{ recipient.email }}</p>

        <template v-if="giftData.message.length > 0">
            <p class="gift-confirmation-subheading">Custom Message:</p>
            <p>"{{ giftData.message }}"</p>
        </template>

        <template v-if="giftData.notificationScheduledAt">
            <p class="gift-confirmation-subheading">Scheduled for:</p>
            <p>{{ formatDate(giftData.notificationScheduledAt) }}</p>
        </template>

        <p class="gift-confirmation-subheading">Billing Info:</p>

        <!-- User -->
        <template v-if="isActiveUser">
            <p>{{ userName }}</p>
            <p>************{{ creditCardLastDigits }}</p>

            <div v-if="creditBalance && creditBalance > 0" class="price-breakdown">
                <p>Total {{ formatPrice(totalAmount) }}</p>
                <p>Credit Used: {{ formatPrice(creditUsed) }}</p>
                <p class="bold">Amount Being Charged: {{ formatPrice(chargedAmount) }}</p>
            </div>
        </template>

        <!-- Non (Active) User -->
        <template v-else>
            <user-form
                    :preset-email="userEmail"
                    :stripe-publishable-key="stripePublishableKey"
                    v-on:submit="submit"
                    ref="userForm"
            />
        </template>

        <button class="complete-btn" @click="submit()">
            <div v-if="loading" class="spinner">&nbsp</div>
            <span v-else>Complete Purchase</span>
        </button>
    </div>
</template>

<script>
    import userForm from '../../common/form-user-simple.vue'
    import CommonMixin from '../../../mixins/common-mixin'
    import DateMixin from '../../../mixins/date-mixin'

    export default {
        components: {
            userForm
        },
        mixins: [
            CommonMixin,
            DateMixin
        ],
        props: {
            giftData: Object,
            userName: String,
            userEmail: String,
            creditCardLastDigits: String,
            creditBalance: Number,
            stripePublishableKey: String
        },
        data: function () {
            return {
                loading: false,
                error: undefined
            }
        },
        methods: {
            submit(userData) {
                if (!this.isActiveUser && !userData) {
                    this.$refs.userForm.validate();
                    return;
                }

                if (this.loading) {
                    return;
                }
                this.$emit('processingOrder');
                this.loading = true;

                this.$api.post('v1/gifts/process_credit_gift', this.getGiftParams(userData))
                    .then(res => this.$emit('purchased', res.data.rewarded_credit_amount_cents))
                    .catch(e => {
                        this.error = 'Sorry, we were unable to process your order. Please update your billing, or contact support@crema.co';
                        this.loading = false;
                        this.$emit('error');
                        console.error(e);
                    })
            },
            getGiftParams(userData) {
                const params = {
                    recipients: this.giftData.recipients,
                    amountEachCents: this.giftData.amountEach,
                    message: this.giftData.message,
                    notificationScheduledAt: this.giftData.notificationScheduledAt
                };

                if (userData) {
                    params.gifter = userData;
                }

                return params;
            }
        },
        computed: {
            numRecipients: function() {
                return this.giftData.recipients.length;
            },
            totalAmount: function() {
                return this.giftData.amountEach * this.numRecipients;
            },
            creditUsed: function() {
                return this.creditBalance >= this.totalAmount ? this.totalAmount : this.creditBalance;
            },
            chargedAmount: function() {
                return this.totalAmount - this.creditUsed;
            },
            isActiveUser: function() {
                return this.creditCardLastDigits
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/common_home";
    @import "../../../styles/form_home.scss";

    .gift-confirmation-content {
        p {
            margin: 0.5rem;
        }
    }
    .gift-confirmation-subheading {
        color: $green-primary;
        margin: 2rem 0 .5rem 0 !important;
    }
    .price-breakdown {
        margin-top: 2rem;
        color: $green-primary;
    }
    .complete-btn {
        @extend .btn-green-lg;
        margin: 2rem auto;
    }
    .error-msg {
        text-align: center!important;
    }

    @media only screen and (max-width: $max-mobile-width) {
    }
</style>
